import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

interface DialogEditImageNameProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  editName: {
    id: string;
    patientid: string;
    filename: string;
  };
}

const DialogEditImageName: React.FC<DialogEditImageNameProps> = (props) => {
  const [filename, setFilename] = useState(props.editName.filename);
  const [errorName, setErrorName] = useState('');

  useEffect(() => {
    setFilename(props.editName.filename);
  }, [props.editName.filename]);

  const handleClose = () => {
    setErrorName('');
    props.onClose();
  };
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFilename(event.target.value);
  };
  const handleSave = () => {
    if (filename === '') {
      setErrorName('ファイル名が無効です');
      return;
    }
    try {
      const token = getToken();
      postAPI(`/patient/change-filename?token=${token}`, {
        filename: filename,
        patientid: props.editName.patientid,
        id: props.editName.id,
        type: 'image',
      }).then((res) => {
        if (res.code === 200) {
          setErrorName('');
          props.onSave();
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          id='filename'
          fullWidth
          variant='standard'
          value={filename}
          onChange={(event) => handleChange(event)}
        />
        {errorName && (
          <Typography color={'#c10015'}>
            {errorName}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ color: '#DA4453' }}>
          キャンセル
        </Button>
        <Button onClick={handleSave}>変更</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogEditImageName;
